import { useEffect, useState } from "react";

export const useEditorMultiSelectInteractions = ({
  playPause,
  editComponent,
  multiSelectedComps,
  setMultiSelectedComps,
  selectedComponent,
  setSelectedComponent,
  layerCompData,
  setLayerCompData,
  setisReferenceFootnotes,
  updateCompValues,
  callOnDragStop,
}) => {
  const [updatedValue, setUpdatedValue] = useState({
    componentStyles: { height: 0, width: 0, top: 0, left: 0 },
  });

  const [multiSelectedComponent, setMultiSelectedComponent] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  const multiSelectionOfComponents = () => {
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;

    for (let i = 0; i < multiSelectedComps.length; i++) {
      let component = multiSelectedComps[i];
      let currentPosition = {
        x: 0,
        y: 0,
      };
      const targetElement = document.getElementById(component.id);
      const canvasElement = document.getElementById("canvas-page");

      if (targetElement && canvasElement) {
        const targetRect = targetElement.getBoundingClientRect();
        const canvasRect = canvasElement.getBoundingClientRect();

        currentPosition = {
          x: targetRect.left - canvasRect.left,
          y: targetRect.top - canvasRect.top,
        };
      }
      if (component.componentStyles) {
        minX = Math.min(minX, currentPosition.x);
        maxX = Math.max(
          maxX,
          currentPosition.x + component.componentStyles.width,
        );
        minY = Math.min(minY, currentPosition.y);
        maxY = Math.max(
          maxY,
          currentPosition.y + component.componentStyles.height,
        );
      }
    }

    if (minX !== Infinity && minY !== Infinity) {
      setUpdatedValue((prevState) => ({
        ...prevState,
        componentStyles: {
          left: minX,
          top: minY,
          width: maxX - minX,
          height: maxY - minY,
        },
      }));

      const tempMultiSelectedComponent = {
        left: minX,
        top: minY,
        width: maxX - minX,
        height: maxY - minY,
      };
      setMultiSelectedComponent(tempMultiSelectedComponent);
    }
  };

  const updateMultiCompProperties = (
    retVal,
    property,
    multiCompAspectRatio,
  ) => {
    if (
      Math.floor(multiSelectedComponent[property]) == retVal ||
      Math.ceil(multiSelectedComponent[property]) == retVal
    ) {
      return;
    }
    let updatedMultiSelectedComps;
    for (let index = 0; index < multiSelectedComps.length; index++) {
      let newWidth = 0;
      let newLeftPosition = 0;
      let newTopPosition = 0;
      let newHeight = 0;
      if (property === "width") {
        const { width: compWidth } =
          multiSelectedComps[index]?.componentStyles || {};
        const { left: compLeft } =
          multiSelectedComps[index]?.componentStyles || {};
        const { width: multiWidth } = multiSelectedComponent || {};
        const { left: multiLeft } = multiSelectedComponent || {};
        const widthDifference = retVal - multiWidth;

        newWidth =
          compWidth +
          ((compWidth ? compWidth : 1) / multiWidth) * widthDifference;
        newLeftPosition =
          compLeft +
          (((compLeft ? compLeft : 1) - multiLeft) / multiWidth) *
            widthDifference;
      } else if (property === "height") {
        const { height: compHeight } =
          multiSelectedComps[index]?.componentStyles || {};
        const { top: compTop } =
          multiSelectedComps[index]?.componentStyles || {};
        const { height: multiHeight } = multiSelectedComponent || {};
        const { top: multiTop } = multiSelectedComponent || {};
        const heightDifference = retVal - multiHeight;

        newHeight =
          compHeight +
          ((compHeight ? compHeight : 1) / multiHeight) * heightDifference;
        newTopPosition =
          compTop +
          (((compTop ? compTop : 1) - multiTop) / multiHeight) *
            heightDifference;
      } else if (property === "top") {
        const { top: compTop } =
          multiSelectedComps[index]?.componentStyles || {};
        const { top: multiTop } = multiSelectedComponent || {};
        const topDifference = retVal - multiTop;
        newTopPosition = compTop + topDifference;
      } else if (property === "left") {
        const { left: compLeft } =
          multiSelectedComps[index]?.componentStyles || {};
        const { left: multiLeft } = multiSelectedComponent || {};
        const leftDifference = retVal - multiLeft;
        newLeftPosition = compLeft + leftDifference;
      }
      updatedMultiSelectedComps = [...multiSelectedComps];

      if (isNaN(newWidth) || newWidth <= 0) {
        newWidth = 1;
      }
      if (isNaN(newHeight) || newHeight <= 0) {
        newHeight = 1;
      }
      if (isNaN(newLeftPosition)) {
        newLeftPosition = 1;
      }
      if (isNaN(newTopPosition)) {
        newTopPosition = 1;
      }
      for (let index2 = 0; index2 < layerCompData.length; index2++) {
        if (layerCompData[index2].id === multiSelectedComps[index].id) {
          if (property === "width") {
            layerCompData[index2].componentStyles.width = newWidth;
            updatedMultiSelectedComps[index].componentStyles.width = newWidth;
            layerCompData[index2].componentStyles.left = newLeftPosition;
            updatedMultiSelectedComps[index].componentStyles.left =
              newLeftPosition;
          } else if (property === "height") {
            layerCompData[index2].componentStyles.height = newHeight;
            updatedMultiSelectedComps[index].componentStyles.height = newHeight;
            layerCompData[index2].componentStyles.top = newTopPosition;
            updatedMultiSelectedComps[index].componentStyles.top =
              newTopPosition;
          } else if (property === "top") {
            layerCompData[index2].componentStyles.top = newTopPosition;
            updatedMultiSelectedComps[index].componentStyles.top =
              newTopPosition;
          } else if (property === "left") {
            layerCompData[index2].componentStyles.left = newLeftPosition;
            updatedMultiSelectedComps[index].componentStyles.left =
              newLeftPosition;
          }
        }
      }
    }

    if (multiCompAspectRatio) {
      let aspectRatio =
        multiSelectedComponent.width / multiSelectedComponent.height;
      let newHeight = retVal / aspectRatio;
      let newWidth = aspectRatio * retVal;

      if (property === "height") {
        updateMultiCompProperties(newWidth, "width", false);
      }
      if (property === "width") {
        updateMultiCompProperties(newHeight, "height", false);
      }
    }
    setMultiSelectedComps(updatedMultiSelectedComps);
  };

  const handleCtrlClick = (e, component) => {
    if (multiSelectedComps.length === 0) {
      component.multiSelected = true;
      setMultiSelectedComps([component]);
      return;
    }
    if (e.ctrlKey) {
      setMultiSelectedComps((prevSelected) => {
        const isSelected = prevSelected.some(
          (comp) => comp.id === component.id,
        );
        if (isSelected) {
          setLayerCompData((prevData) =>
            prevData.map((comp) =>
              comp.id === component.id
                ? { ...comp, multiSelected: false }
                : comp,
            ),
          );
          return prevSelected.filter((comp) => comp.id !== component.id);
        } else {
          component.multiSelected = true;
          return [...prevSelected, component];
        }
      });
      setSelectedComponent({
        componentType: "default",
        componentStyles: { left: null, top: null },
      });
    } else if (multiSelectedComps.length == 1) {
      const updatedLayerCompData = layerCompData.map((comp) => {
        if (comp.id !== component.id) {
          return {
            ...comp,
            multiSelected: false,
          };
        }
        return comp;
      });
      setLayerCompData(updatedLayerCompData);
      component.multiSelected = true;
      setMultiSelectedComps([component]);
      setSelectedComponent(component);
    } else {
      const isSelected = multiSelectedComps.some(
        (comp) => comp.id === component.id,
      );
      if (isSelected) {
        setSelectedComponent({
          componentType: "default",
          componentStyles: { left: null, top: null },
        });
      } else {
        component.multiSelected = true;
        setMultiSelectedComps([component]);
        setLayerCompData((prevData) =>
          prevData.map((comp) => ({
            ...comp,
            multiSelected: false,
          })),
        );
      }
    }
  };

  const handleComponentsDrag = (d, component) => {
    const isComponentPresent = multiSelectedComps.some(
      (comp) => comp.id === component.id,
    );
    if (!isComponentPresent || multiSelectedComps.length === 1) {
      const updatedLayerCompData = layerCompData.map((comp) => {
        if (comp.id !== component.id) {
          return {
            ...comp,
            multiSelected: false,
          };
        }
        return comp;
      });
      setSelectedComponent(component);
      setLayerCompData(updatedLayerCompData);
      component.multiSelected = true;
      setMultiSelectedComps([component]);
      updateCompValues({
        x: d.x - (parseInt(component.componentStyles.translateX) || 0),
        y: d.y - (parseInt(component.componentStyles.translateY) || 0),
        id: component.id,
      });
    } else {
      updateMultiCompProperties(
        multiSelectedComponent.left +
          (d.x -
            (component.componentStyles.left +
              (component.componentStyles.translateX || 0))),
        "left",
        false,
      );
      updateMultiCompProperties(
        multiSelectedComponent.top +
          (d.y -
            (component.componentStyles.top +
              (component.componentStyles.translateY || 0))),
        "top",
        false,
      );
    }
  };

  const handleComponentsDragStop = (e, d, component, index) => {
    if (multiSelectedComps.length > 1) {
      updateMultiCompProperties(
        multiSelectedComponent.left +
          (d.x -
            (component.componentStyles.left +
              (component.componentStyles.translateX || 0))),
        "left",
        false,
      );
      updateMultiCompProperties(
        multiSelectedComponent.top +
          (d.y -
            (component.componentStyles.top +
              (component.componentStyles.translateY || 0))),
        "top",
        false,
      );
    } else {
      callOnDragStop({
        e,
        x: d.x - (parseInt(component.componentStyles.translateX) || 0),
        y: d.y - (parseInt(component.componentStyles.translateY) || 0),
        id: component.id,
        index: index,
      });
    }
  };

  const isMultiSelectComponentVisible = () => {
    const hasMultipleLayers =
      Array.isArray(multiSelectedComps) && multiSelectedComps.length > 1;
    const isSingleSelectedAsMulti =
      multiSelectedComps.length === 1 &&
      selectedComponent.id === multiSelectedComps[0].id;
    return (
      hasMultipleLayers &&
      !isSingleSelectedAsMulti &&
      multiSelectedComps.length !== 0 &&
      multiSelectedComponent.height !== 0 &&
      multiSelectedComponent.width !== 0 &&
      !editComponent
    );
  };

  useEffect(() => {
    if (playPause.animationCompleted && !editComponent) {
      multiSelectionOfComponents();
    }
  }, [multiSelectedComps, playPause.animationCompleted]);

  useEffect(() => {
    if (selectedComponent.id && layerCompData.length > 0) {
      setMultiSelectedComps([selectedComponent]);
      setLayerCompData((prevData) =>
        prevData.map((comp) => ({
          ...comp,
          multiSelected: comp.id === selectedComponent.id,
        })),
      );
    }
    const isRefFoot = layerCompData.some(
      (component) =>
        component.textComponentType.addContent === "Reference" ||
        component.textComponentType.addContent === "Footnotes",
    );
    setisReferenceFootnotes(isRefFoot);
  }, [layerCompData.length]);

  return {
    updatedValue,
    setUpdatedValue,
    multiSelectedComponent,
    setMultiSelectedComponent,
    updateMultiCompProperties,
    handleCtrlClick,
    handleComponentsDrag,
    handleComponentsDragStop,
    isMultiSelectComponentVisible,
  };
};
